<div [formGroup]="formGroup">
    <ng-container *ngIf="!formGroup.get(controlName).disabled || !detailMode">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <mat-form-field appearance="outline" floatLabel="always" color="accent" style="width: 100%;">
            <input matInput 
                [matDatepicker]="dateControl" 
                [placeholder]="placeholder"
                [min]="minDate"
                [formControlName]="controlName" readonly>
            <mat-datepicker-toggle [disabled]="!formGroup.get(controlName).enabled" 
                matSuffix 
                [for]="dateControl">
            </mat-datepicker-toggle>                                
            <mat-datepicker #dateControl disabled="false"></mat-datepicker>
            <!-- errors -->
            <!-- <mat-hint *ngIf="getError('required')">{{'AUTH.VALIDATION.REQUIRED_FIELD' | translate}}</mat-hint>  -->
        </mat-form-field>
    </ng-container>

    <ng-container *ngIf="formGroup.get(controlName).disabled && detailMode">
        <mat-label class="font-weight-400">{{label}}</mat-label>
        <p *ngIf="formGroup.get(controlName).value" style="font-weight: bold;">{{formGroup.get(controlName).value | date: 'dd/MM/yyyy'}}</p>
        <p *ngIf="!formGroup.get(controlName).value" style="font-weight: bold;">{{'-'}}</p>
    </ng-container>
</div>